import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/spreadsheet-guide/page";
import ProductsPage from "@/pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;